import { zodResolver } from "@hookform/resolvers/zod";
import { Stack } from "@mui/material";
import { FormFields } from "Components/Merchant/Initiate/InitiatePaymentForm/FormFields";
import {
  type InitiatePaymentFormData,
  initiateMerchantSchema,
} from "Components/Merchant/Initiate/InitiatePaymentForm/schema";
import { PrimaryButton } from "Components/Shared/Buttons/PrimaryButton";
import type { BankAccountListItem } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { type FieldErrors, useForm } from "react-hook-form";

const PageResources = Resources.Merchant.Initiate;

type Props = {
  bankAccounts: Array<BankAccountListItem>;
  defaultValues: Partial<InitiatePaymentFormData>;
  onSubmit: (data: InitiatePaymentFormData) => void;
  isSubmitting?: boolean;
  isDisabled?: boolean;
  errors: FieldErrors<InitiatePaymentFormData>;
};

export const InitiatePaymentForm = ({
  bankAccounts,
  defaultValues,
  onSubmit,
  isSubmitting,
  isDisabled,
  errors,
}: Props) => {
  const { t } = useResource();

  const { handleSubmit, control } = useForm<InitiatePaymentFormData>({
    resolver: zodResolver(initiateMerchantSchema),
    errors,
    defaultValues,
  });

  return (
    <Stack
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      justifyContent="space-between"
      height={["100%", "auto"]}
    >
      <FormFields control={control} bankingAccounts={bankAccounts} />
      <PrimaryButton
        fullWidth
        type="submit"
        color="primary"
        disabled={isDisabled || isSubmitting}
        loading={isSubmitting}
      >
        {t(PageResources.GenerateButton)}
      </PrimaryButton>
    </Stack>
  );
};
